module.exports = __webpack_public_path__ + "img/fishing-5.3e98e938.jpg";